import Nullstack from 'nullstack';
export default function IconTimelineEventExclamation({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-timeline-event-exclamation",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "20",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M10 20h-6"
  }), "   ", Nullstack.element("path", {
    d: "M14 20h6"
  }), "   ", Nullstack.element("path", {
    d: "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z"
  }), "   ", Nullstack.element("path", {
    d: "M12 6v2"
  }), "   ", Nullstack.element("path", {
    d: "M12 11v.01"
  }), " ");
}